import React from 'react';
import Banner from './Banner';

export const RECONVENE_HEADER = 'Launch your dream event with our help';

interface ReconveneBannerProps {
    handleTracking?: Function;
    trackingParams?: string;
    category?: string;
}

const ReconveneBanner: React.FunctionComponent<ReconveneBannerProps> = (
    props,
) => {
    const trackingData = {
        type: 'TRACK_RECONVENE_BANNER_CLICK_REGISTER_NOW',
        meta: {
            analytics: {
                action: 'RECONVENEBannerClickRegisterNow',
                category: props.category,
            },
        },
    };

    const destinationURL =
        'https://www.eventbrite.com/l/reconvene-accelerator/?utm_source=reconvene&utm_medium=homepage&utm_campaign=accelerator_announcement';

    return (
        <Banner
            leftAccentColor="#F05537"
            style="dark"
            header={RECONVENE_HEADER}
        >
            <span>
                Calling all creators! Eventbrite&#39;s RECONVENE Accelerator
                offers coaching and $10k awards to creators who build community
                and shape culture.{' '}
                <a
                    onClick={() => {
                        props.handleTracking?.(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    Apply now!
                </a>
            </span>
        </Banner>
    );
};

export default ReconveneBanner;
